/* eslint-disable react/no-danger */
import _ from 'lodash'
import React from 'react'
import PropTypes, { object } from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import moment from 'moment-timezone'
import { withTranslation } from 'react-i18next'
import {
  Form,
  Row,
  Col,
  Button,
  Input,
  Modal,
  Select,
  Tag,
  Checkbox,
  Statistic,
  DatePicker,
} from 'antd'

import { Banner, QuillContent } from '@client/components/index'
import { CheckHostExist, AppContainer, CompetitionNavigation } from '@client/containers/index'
import actions from '@client/actions'
import { FIELD_TYPE } from '@client/constants/fieldType'
import paperStyles from '@client/styles/paper.styl'
import styles from './SignUp.styl'

const { Item } = Form
const { TextArea } = Input
const { Option } = Select

const mapStateToProps = (state) => ({
  host: state.host.data,
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
})

class SignUp extends React.Component {
  static propTypes = {
    actions: object.isRequired,
    form: object.isRequired,
    host: object.isRequired,
    match: object.isRequired,
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  state = {
    showPrivacyModal: false,
    privacyCheckStatus: false,
  }

  nonEmptyRule = () => {
    const { t } = this.props
    return [
      {
        required: true,
        message: t('必填'),
      },
    ]
  }

  handleSignUp = () => {
    const {
      form: { resetFields, validateFieldsAndScroll },
      match: {
        params: { hostId, competitionId },
      },
      t,
      host: { payment_url },
    } = this.props
    validateFieldsAndScroll({ scroll: { offsetTop: '100' } }, (err, formData) => {
      if (err) return
      this.props.actions.addTeam(competitionId, hostId, formData).then((res) => {
        if (!res) return
        Modal.success({
          title: t('報名成功'),
          content: t('請至信箱收取相關資訊，謝謝！'),
          okText: t('確認'),
        })
        if (payment_url) {
          window.open(payment_url, 'paymentWebsite')
        }
        resetFields()
      })
    })
  }

  checkRepeatEmail = (rule, value, callback) => {
    const { t } = this.props
    if (value) {
      const {
        form: { getFieldsValue },
      } = this.props
      const formData = getFieldsValue(['users'])
      const countByEmail = _.countBy(formData.users, 'email')
      if (countByEmail[value] > 1) callback(t('請勿填寫重複的email'))
    }
    callback()
  }

  checkEmailAlreadyApplied = (rule, value, callback) => {
    const { t } = this.props
    this.props.actions.setLoadingMask({ isEnable: false })
    if (value) {
      const {
        actions: { checkUserEmail },
        match: {
          params: { hostId, competitionId },
        },
      } = this.props
      checkUserEmail(competitionId, hostId, value).then(
        ({
          payload: {
            data: { check },
          },
        }) => {
          if (!check) callback(t('該email已申請過'))
          else callback()
          this.props.actions.setLoadingMask({ isEnable: true })
        },
      )
    } else {
      callback()
    }
  }

  renderMember = (count = 0) => {
    const {
      form: { getFieldDecorator },
      match: {
        params: { hostId, competitionId },
      },
      t,
    } = this.props

    return Array.from(Array(count).keys()).map((index) => {
      const isCaptain = index === 0

      return (
        <Col key={index} sm={12} md={12} xl={6}>
          <Tag color="#71CDF4">{isCaptain ? t('隊長') : `${t('隊員')}${index}`}</Tag>
          <Item label={t('姓名')}>
            {getFieldDecorator(`users[${index}].name`, {
              rules: this.nonEmptyRule(),
            })(<Input />)}
          </Item>
          {getFieldDecorator(`users[${index}].competition_id`, {
            initialValue: competitionId,
          })(<Input hidden />)}
          {getFieldDecorator(`users[${index}].host_id`, {
            initialValue: hostId,
          })(<Input hidden />)}
          {getFieldDecorator(`users[${index}].is_captain`, {
            valuePropName: 'checked',
            initialValue: isCaptain,
          })(<Checkbox style={{ display: 'none' }} />)}
          <Item label={t(`${t('信箱')}（${t('這將成為您的登入帳號')}）`)}>
            {getFieldDecorator(`users[${index}].email`, {
              rules: [
                ...this.nonEmptyRule(),
                {
                  type: 'email',
                  message: t('錯誤的信箱格式'),
                },
                {
                  validator: this.checkRepeatEmail,
                },
              ],
            })(<Input />)}
          </Item>
          {this.renderCustomFields(index)}
        </Col>
      )
    })
  }

  renderCustomFields = (index) => {
    const formFormat = this.props.host.form_format || {}
    const { format = [] } = formFormat
    const {
      form: { getFieldDecorator },
    } = this.props
    const fieldList = format

    return fieldList.map((field) => (
      <Item key={field.name} label={field.name}>
        {(() => {
          if (field.type === FIELD_TYPE.TEXT) {
            return getFieldDecorator(`users[${index}].others.${field.name}`, {
              rules: this.nonEmptyRule(),
            })(<TextArea />)
          }
          if (field.type === FIELD_TYPE.DATE) {
            return getFieldDecorator(`users[${index}].others.${field.name}`, {
              rules: this.nonEmptyRule(),
            })(<DatePicker />)
          }
          if (field.type === FIELD_TYPE.SELECT) {
            return getFieldDecorator(`users[${index}].others.${field.name}`, {
              rules: this.nonEmptyRule(),
            })(
              <Select>
                {field.options.map((option) => (
                  <Option key={option} value={option}>
                    {option}
                  </Option>
                ))}
              </Select>,
            )
          }
          return null
        })()}
      </Item>
    ))
  }

  handlePolicyCheckChange = (e) => {
    this.setState({
      privacyCheckStatus: e.target.checked,
    })
  }

  handleMemberCountChange = (value) => {
    if (value) {
      this.setState({
        privacyCheckStatus: false,
        showPrivacyModal: true,
      })
    }
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldsValue, setFieldsValue },
      host,
      match,
      t,
    } = this.props
    const {
      params: { hostId, competitionId },
    } = match
    const { competition = {} } = host
    const { member_count = [], signup_info } = host
    const { showPrivacyModal, privacyCheckStatus } = this.state
    const formData = getFieldsValue(['member_count'])

    return (
      <AppContainer style={{ padding: '0px 0 30px 0' }}>
        <Helmet>
          <title>{t('我要報名')}</title>
        </Helmet>
        <Banner backgroundImage={competition.cover} disabledLogo />
        <Row type="flex" justify="center">
          <CompetitionNavigation match={match} />
        </Row>
        <Row type="flex" justify="center" style={{ margin: '50px 0 20px 0' }}>
          <h1>{t('報名規則說明')}</h1>
        </Row>
        <Row type="flex" justify="center">
          <Col span={20} className={paperStyles.paper}>
            <QuillContent content={signup_info} />
          </Col>
        </Row>
        {moment().isBetween(host.signup_start_time, host.signup_end_time, 'day', '[]') ? (
          <Row type="flex" justify="center">
            <Col span={22}>
              <Form>
                <Row type="flex" justify="center" gutter={16}>
                  <Col sm={12} md={8} xl={5}>
                    <Tag color="#71CDF4">{t('基本資料')}</Tag>
                    {getFieldDecorator('competition_id', {
                      initialValue: competitionId,
                    })(<Input hidden />)}
                    {getFieldDecorator('host_id', {
                      initialValue: hostId,
                    })(<Input hidden />)}
                    <Item label={t('團隊名稱')}>
                      {getFieldDecorator('name', {
                        rules: this.nonEmptyRule(),
                      })(<Input />)}
                    </Item>
                    <Item label={t('團隊簡介')}>
                      {getFieldDecorator('description', {
                        rules: this.nonEmptyRule(),
                      })(<TextArea />)}
                    </Item>
                    <Item label={t('參賽動機')}>
                      {getFieldDecorator('motivation', {
                        rules: this.nonEmptyRule(),
                      })(<TextArea />)}
                    </Item>
                    <Item label={t('參賽人數')}>
                      {getFieldDecorator('member_count', {
                        rules: this.nonEmptyRule(),
                      })(
                        <Select onChange={this.handleMemberCountChange}>
                          {member_count.map((count) => (
                            <Option key={count} value={count}>
                              {count}
                            </Option>
                          ))}
                        </Select>,
                      )}
                    </Item>
                  </Col>
                  {this.renderMember(formData.member_count)}
                </Row>

                <Row type="flex" justify="center" style={{ margin: '20px' }}>
                  <Button className="primary" onClick={this.handleSignUp}>
                    {t('送出')}
                  </Button>
                </Row>
              </Form>
            </Col>
          </Row>
        ) : (
          <>
            <h2 style={{ textAlign: 'center', padding: '1rem 0' }}>{t('報名期間')}</h2>
            <Row type="flex" justify="center">
              <Col span={8}>
                <Statistic
                  style={{ textAlign: 'center', backgroundColor: 'white', padding: '1rem 0' }}
                  title={t('報名開始')}
                  value={moment(host.signup_start_time).format('YYYY-MM-DD')}
                />
              </Col>
              <Col span={8}>
                <Statistic
                  style={{ textAlign: 'center', backgroundColor: 'white', padding: '1rem 0' }}
                  title={t('報名結束')}
                  value={moment(host.signup_end_time).format('YYYY-MM-DD')}
                />
              </Col>
            </Row>
          </>
        )}
        <Modal
          width="80%"
          visible={showPrivacyModal}
          title={
            <div
              className={styles.modalTitle}
              dangerouslySetInnerHTML={{ __html: t('PRIVACY_TITLE') }}
            />
          }
          onOk={() => {
            this.setState({ showPrivacyModal: false })
          }}
          onCancel={() => {
            setFieldsValue({ member_count: undefined })
            this.setState({ showPrivacyModal: false })
          }}
          okText={t('確認')}
          okButtonProps={{ disabled: !privacyCheckStatus }}
        >
          <div
            className={styles.modal}
            dangerouslySetInnerHTML={{
              __html: t('PRIVACY_CONTENT', {
                siteLink: process.env.CLIENT ? window.location.origin : '',
              }),
            }}
          />
          <br />
          <Checkbox checked={privacyCheckStatus} onChange={this.handlePolicyCheckChange}>
            <span className={styles.checkboxWording}>{t('PRIVACY_AGREE_CHECKBOX_WORDING')}</span>
          </Checkbox>
        </Modal>
        {/* <Modal
          visible={showAgreementModal}
          title={
            <div
              className={styles.modalTitle}
              dangerouslySetInnerHTML={{ __html: t('AGREEMENT_TITLE') }}
            />
          }
          onOk={this.handleSignUp}
          onCancel={() => this.setState({ showAgreementModal: false })}
          okText={t('同意')}
        >
          <div
            className={styles.modal}
            dangerouslySetInnerHTML={{
              __html: t('AGREEMENT_CONTENT', {
                siteLink: process.env.CLIENT ? window.location.origin : '',
              }),
            }}
          />
        </Modal> */}
      </AppContainer>
    )
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  CheckHostExist,
  withTranslation(),
  Form.create(),
)(SignUp)
